import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "../core";
import { AccountPosSystemSettings, AccountPosSystemSettingsDto } from "../dto";

@Injectable({ providedIn: "root" })
export class PosSystemService {
  protected serviceUrl = "PosSystem";

  constructor(protected api: ApiService) {}

  getAccountPosSystemSettings(): Observable<AccountPosSystemSettings> {
    return this.api
      .get<AccountPosSystemSettingsDto>(`${this.serviceUrl}/settings`)
      .pipe(map((data: AccountPosSystemSettingsDto) => AccountPosSystemSettings.fromDto(data)));
  }
}
